import { faScaleBalanced as faScaleBalancedLight } from '@fortawesome/pro-light-svg-icons';
import { faGears, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { LegalDocumentList } from '~/components/organisms/LegalDocumentList';

export type IAppLegalDocumentsPageProps = {
  appId: string;
};

export const AppLegalDocumentsPage: React.FC<IAppLegalDocumentsPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();

  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppLegalDocumentsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faScaleBalancedLight} />}
        title={t('AppLegalDocumentsPage.title')}
        subtitle={t('AppLegalDocumentsPage.subtitle')}
        actions={
          <Button
            href={`/apps/${appId}/settings/legalDocuments/create`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('AppLegalDocumentsPage.create')}
          </Button>
        }
        previousUrl={parentUrl}
      />

      <LegalDocumentList appId={appId} />
    </>
  );
};
